import { useEffect, useMemo, useState } from "react";
import { api } from "../../api";
import { Button } from "../../components/ui/button";
import { LanguageSelect } from "../../components/LanguageSelect";
import { useLanguage } from "../../contexts/LanguageContext";
import { onboardingLabels } from "./labels";
import { navigate } from "../../lib/router";
// Floating-time: no timezone selection needed

export default function SetupCompanyPage() {
  const { lang } = useLanguage();
  const t = onboardingLabels[lang];
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const interval = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => {
      window.clearInterval(interval);
    };
  }, []);
  const formattedPreview = useMemo(() => {
    try {
      const locale = lang === "pt" ? "pt-BR" : "en-US";
      return new Intl.DateTimeFormat(locale, {
        dateStyle: "full",
        timeStyle: "medium",
      }).format(now);
    } catch (error) {
      return "";
    }
  }, [lang, now]);

  const save = async () => {
    await api.updateCompany({ language: lang });
    navigate("/app/appointments");
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-6">
        <h1 className="text-xl font-semibold text-center">{t.title}</h1>
        <div className="space-y-4">
          <div className="flex flex-col gap-2">
            <LanguageSelect
              labels={t.language}
              className="w-full"
              variant="cards"
            />
          </div>
          {/* Timezone selection removed in floating-time model */}
          <Button onClick={save} className="w-full">
            {t.actions.save}
          </Button>
        </div>
      </div>
    </div>
  );
}
